import React from "react";

import styles from "./Var.module.scss";

type Props = { pluralize?: number; children: React.ReactNode };

export default function Var({ pluralize, children }: Props) {
  const attributes =
    pluralize || pluralize === 0 ? { "data-pluralize": pluralize } : {};
  return (
    <var className={styles.var} {...attributes}>
      {children}
    </var>
  );
}
